/**
* Content Scroll JS
* -----------------------------------------------------------------------------
*
* All the JS for the Content Scroll component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'content-scroll',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.content-scroll' ).each( function( key, component ) {
        // get nav heights and whatnot
        const docStyle = getComputedStyle( document.documentElement );
        const navHeight = docStyle.getPropertyValue( '--navbarHeight' );
        const adminbarHeight = docStyle.getPropertyValue( '--wp-admin--admin-bar--height' ).length > 0 ? docStyle.getPropertyValue( '--wp-admin--admin-bar--height' ) : 0;
        const topOffset = parseInt( navHeight ) + parseInt( adminbarHeight );
        // -------

        // set up some variables
        const originalPanelHeight = $( this ).find( '.content-scroll__panel' ).height();
        const speed = 2; // higher is slower
        const panelHeight = originalPanelHeight * ( 1 + ( 0.25 * speed ) );
        const panelsCount = $( this ).find( '.content-scroll__panel' ).length;

        // set the height of the component to the desired speed
        $( component ).height( $( component ).find( '.content-scroll__panel' ).height() * ( panelsCount + speed ) );

        // pin the component
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: component,
            pin: $( component ).find( '.content-scroll__panels' )[0],
            start: 'top ' + topOffset,
            end: 'bottom bottom',
            scrub: 0,
          },
        } );

        // scroll to appropriate panel when pagination is clicked
        $( component ).find( '.content-scroll__pagination-panel a' ).on( 'click', function() {
          window.scrollTo( {
            top: $( component ).position().top + ( panelHeight * $( this ).index() ) + 20,
            left: 0,
            behavior: 'smooth',
          } );
        } );

        // loop through each panel to set up the revealing of it
        $( component ).find( '.content-scroll__panel:not(:first-child)' ).each( function( panelKey, panel ) {
          // reveal the content
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: panel,
              start: ( panelHeight * ( panelKey ) ) + ' ' + topOffset,
              end: '+=' + panelHeight,
              onUpdate: ( self ) => {
                // show the panel when you enter it, and hide the previous one
                if ( self.progress < 0.01 ) {
                  if ( panelKey > 0 ) { // don't hide the first one when you go backwards
                    $( panel ).prev().find( '.content-scroll__content' ).addClass( 'is-active' );
                    $( panel ).find( '.content-scroll__content' ).removeClass( 'is-active' );
                  }
                } else {
                  $( panel ).prev().find( '.content-scroll__content' ).removeClass( 'is-active' );
                  $( panel ).find( '.content-scroll__content' ).addClass( 'is-active' );
                }

                // update the active page when it's related panel is hit
                if ( ( self.progress > 0.01 && self.progress < 0.99 ) || ( self.progress <= 0.01 && panelKey == 0 ) ) {
                  $( component ).find( '.content-scroll__pagination-panel a:nth-child(' + ( panelKey + 1 ) + ')' ).addClass( 'is-active' );
                } else {
                  $( component ).find( '.content-scroll__pagination-panel a:nth-child(' + ( panelKey + 1 ) + ')' ).removeClass( 'is-active' );
                }
              },
              scrub: 0,
            },
          } );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'content-scroll', COMPONENT );
} )( app );
